/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class SuccessDialog extends Component {
  // passed in
  isOpen = false;

  title = null;
  message = null;
  buttonLabel = 'Got it';
  onClose = null;
}
